import { OperationService } from "@/services";
import { mapActions } from "vuex";
import * as types from "@/store/types";

const Deposit = () => import("@/components/OrderProcessPage/Deposit/index");
const Withdrawal = () =>
  import("@/components/OrderProcessPage/Withdrawal/index");
const Exchange = () => import("@/components/OrderProcessPage/Exchange/index");
const transitionPage = () => import("@/components/transitionPage/index");
const Transfer = () => import("@/components/OrderProcessPage/Transfer/index");
export default {
  name: "order-process-page",
  components: { Deposit, Withdrawal, Exchange, transitionPage, Transfer },
  props: [],
  data() {
    return {};
  },
  computed: {},
  mounted() {
    this.getOrderConfigStep();
  },
  methods: {
    ...mapActions({
      setOrderStep: types.operations.actions.ACTION_ORDER_STEP
    }),
    getOrderConfigStep() {
      let refNo = this.$route.params.id;

      OperationService.getOrderConfig(refNo).then(response => {
        this.setOrderStep(response.data.data.step);
      });
    }
  }
};
